/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupFullDTO,
  ClassSignupFullDTOOptional,
  ClassSignupFullDTOMetaI,
  ClassSignupFullDTOTrackedI,
} from "./class-signup-full-dto";
import {
  ClassSignupFullDTOTracked,
  ClassSignupFullDTOMeta,
} from "./class-signup-full-dto";

/**
 *
 * @export
 * @interface ClassSignupResponseDTO
 */
export interface ClassSignupResponseDTOOptional {
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassSignupResponseDTO
   */
  classSignup?: ClassSignupFullDTOOptional;
  /**
   *
   * @type {string}
   * @memberof ClassSignupResponseDTO
   */
  errors?: string;
}

export interface ClassSignupResponseDTO extends ClassSignupResponseDTOOptional {
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassSignupResponseDTO
   */
  classSignup?: ClassSignupFullDTO;
  /**
   *
   * @type {string}
   * @memberof ClassSignupResponseDTO
   */
  errors?: string;
}

export interface ClassSignupResponseDTOTrackedI {
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassSignupResponseDTO
   */
  classSignup?: ClassSignupFullDTOTrackedI;
  classSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupResponseDTO
   */
  errors?: string;
  errorsIsSet: boolean;
}

transformDatesMap.set(
  "ClassSignupResponseDTO",
  function (model: ClassSignupResponseDTO) {
    const transformDatesclassSignup =
      transformDatesMap.get("ClassSignupFullDTO");
    if (transformDatesclassSignup && model.classSignup) {
      transformDatesclassSignup(model.classSignup);
    }
  },
);

export type ClassSignupResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classSignup: PropertyMeta<ClassSignupFullDTOMetaI>;
  //isDate: false
  //isDatetime: false
  errors: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassSignupResponseDTOMeta: ClassSignupResponseDTOMetaI =
  {} as ClassSignupResponseDTOMetaI;
ClassSignupResponseDTOMeta = typeMeta("ClassSignupResponseDTO", {
  classSignup: propertyMeta(
    "classSignup",
    false,
    false,
    false,
    ClassSignupFullDTOMeta,
  ),
  errors: propertyMeta("errors", false, false, false, MetaTypesBase.string),
});

const metaI = ClassSignupResponseDTOMeta;

registerMeta(() => {});

export class ClassSignupResponseDTOTracked implements ClassSignupResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classSignup__I?: ClassSignupFullDTOTracked = undefined;
  classSignupIsSet: boolean = false;
  set classSignup(v: undefined | ClassSignupFullDTOTracked) {
    if (v !== undefined) {
      this.classSignup__I = v;
      this.classSignupIsSet = true;
    } else {
      this.classSignup__I = v || undefined;
      this.classSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get classSignup() {
    return this.classSignup__I;
  }
  errors__I?: string = undefined;
  errorsIsSet: boolean = false;
  set errors(v: undefined | string) {
    if (v !== undefined) {
      this.errors__I = v;
      this.errorsIsSet = true;
    } else {
      this.errors__I = v || undefined;
      this.errorsIsSet = false;
    }
    this.changeTracker = true;
  }
  get errors() {
    return this.errors__I;
  }
  constructor(
    config?: ClassSignupResponseDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classSignup?.setIds();
  }
  assignFrom(
    config: ClassSignupResponseDTOOptional,
    options?: AssignOptions,
  ): ClassSignupResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classSignup &&
      this.classSignupApplyFilter(optionsRequired.filter)
    ) {
      this.classSignup = new ClassSignupFullDTOTracked(
        config.classSignup,
        options,
      );
      if (optionsRequired.unassign) this.classSignupIsSet = false;
      else this.classSignupIsSet = true;
    }
    if (config.errors && this.errorsApplyFilter(optionsRequired.filter)) {
      this.errors = config.errors;
      if (optionsRequired.unassign) this.errorsIsSet = false;
      else this.errorsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSignupResponseDTOTrackedI {
    const cloned = {} as ClassSignupResponseDTOTrackedI;
    if (
      this.classSignupIsSetDeep() &&
      this.classSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classSignupIsSet = true;
      cloned.classSignup = this.classSignup?.removeUnset(filter);
    } else {
      //cloned.classSignupIsSet = false
    }
    if (
      this.errorsIsSetDeep() &&
      this.errorsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.errorsIsSet = true;
      cloned.errors = this.errors;
    } else {
      //cloned.errorsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSignupResponseDTOTrackedI {
    if (!this.classSignupApplyFilter(filter)) this.classSignupIsSet = false;
    this.classSignup?.unassignAll(filter);

    if (!this.errorsApplyFilter(filter)) this.errorsIsSet = false;

    return this;
  }
  classSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupResponseDTOMeta.classSignup,
      ClassSignupResponseDTOMeta,
      this.classSignup,
      this,
    );
  }
  classSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classSignupIsSet && this.classSignupApplyFilter(filter))
      return true;
    return this.classSignup?.anySet(filter) == true;

    return false;
  }
  errorsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupResponseDTOMeta.errors,
      ClassSignupResponseDTOMeta,
      this.errors,
      this,
    );
  }
  errorsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.errorsIsSet && this.errorsApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classSignupIsSetDeep(filter)) return true;
    if (this.errorsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
